import { HeroHalfTest } from 'types/studio/studio';
import StudioResponsiveMedia from 'shared/studio/StudioResponsiveMedia/StudioResponsiveMedia';
import styles from './HeroHalfTestMedia.module.scss';

type Props = Pick<HeroHalfTest, 'contentPosition' | 'media'> & { visibleOnPageLoad: boolean };

const HeroHalfTestMedia = ({ media, contentPosition, visibleOnPageLoad }: Props) => (
  <StudioResponsiveMedia
    {...media}
    className={styles.imageCont}
    childClassName={[styles.image, contentPosition === 'left' ? styles.imageLeft : '']}
    eagerLoading={visibleOnPageLoad}
  />
);

export default HeroHalfTestMedia;
